import axios from 'axios';
import { Toast } from 'vant';

 import router from '../router/index'
export default {
  install: function(Vue,) {
    // var fileAddr={url:"http://localhost:24737/"};
    // var fileAddr={url:"http://mall.reaca.net:8099/"};
    var fileAddr={url:"https://oss.reaca.net/"};
    var axiosInstance = axios.create({
      // baseURL: 'http://localhost:24737/api/',      
      // baseURL:'http://mall.reaca.net:8099/api/',      
      // baseURL:'https://sale.reaca.net/api/',      
      baseURL:'https://api.reaca.net/api/',      
      withCredentials: true,
      crossDomain: true,  
      /* other custom settings */
    });
    axiosInstance.SetConditions=function(conditonsArray){
      var Conditions=[];
      for (const key in conditonsArray) {
        if (conditonsArray.hasOwnProperty(key)) {
          Conditions.push(conditonsArray[key]);          
        }
      }
      axiosInstance.defaults.headers.QueryConditionList=encodeURI(JSON.stringify(Conditions));
    };
    // axiosInstance.SetUserId=function(id){
    //   axiosInstance.defaults.headers.UserId=id;
    // };
    axiosInstance.interceptors.response.use((res) => {
      axiosInstance.SetConditions([]);
      // 在这里对返回的数据进行处理
      // if(res.data=="登录超时！"){      
      //   Toast.fail({
      //     content: "您还没有登录哦",
      //     duration: 10,
      //     closable: true
      //   });        
      //    router.push('/login')                  
      // }
      // if(res.data=="您没有权限操作！"){      
                   
      // }
      return res;
      
    }, (error) => {
      
      // TODO 待补充
      Toast.fail("网络异常！");  
      return Promise.reject(error)
    });
    Object.defineProperty(Vue.prototype, '$http', { value: axiosInstance });
    Object.defineProperty(Vue.prototype, '$http_d', { value: axios });
    Object.defineProperty(Vue.prototype,'$file',{value:fileAddr});
  }
}